"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const LaunchOutlined_1 = __importDefault(require("@material-ui/icons/LaunchOutlined"));
const Stack_1 = __importDefault(require("../../layouts/Stack"));
const Box_1 = __importDefault(require("../../layouts/Box"));
const LoadingIndicator_1 = __importDefault(require("../LoadingIndicator"));
const Heading_1 = __importDefault(require("../Heading"));
const core_1 = require("@material-ui/core");
const useStyles = makeStyles_1.default((theme) => ({
    header: {
        fontSize: '18px',
        padding: '20px 56px 20px 30px',
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
    },
    content: {
        paddingTop: '10px',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    divider: {
        marginTop: '25px',
        marginBottom: '25px',
    },
    learnMore: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            marginLeft: theme.spacing(0.5),
        },
    },
}));
/** A help panel, designed to be rendered as part of the App Layout */
const HelpPanel = ({ header: headerLabel = '', children, learnMoreFooter, loading = false, }) => {
    const styles = useStyles();
    const header = react_1.useMemo(() => {
        return (react_1.default.createElement(Box_1.default, { className: styles.header },
            react_1.default.createElement(Heading_1.default, { variant: "h2" }, headerLabel)));
    }, [headerLabel, styles]);
    const content = react_1.useMemo(() => {
        return (react_1.default.createElement(Box_1.default, { className: styles.content },
            children,
            learnMoreFooter && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Divider_1.default, { className: styles.divider }),
                react_1.default.createElement(Stack_1.default, { spacing: "s" },
                    react_1.default.createElement(core_1.Typography, { variant: "h3", className: styles.learnMore },
                        "Learn more ",
                        react_1.default.createElement(LaunchOutlined_1.default, { fontSize: "small" })),
                    learnMoreFooter.map((link, index) => (react_1.default.createElement(react_1.Fragment, { key: index }, link))))))));
    }, [children, learnMoreFooter, styles]);
    return (react_1.default.createElement(Box_1.default, null, loading ? (react_1.default.createElement(LoadingIndicator_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
        header,
        react_1.default.createElement(Divider_1.default, null),
        content))));
};
exports.default = HelpPanel;
//# sourceMappingURL=index.js.map